import script from "./LeadershipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadershipModal.vue?vue&type=script&setup=true&lang=js"

import "./LeadershipModal.vue?vue&type=style&index=0&id=dcf91f36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcf91f36"]])

export default __exports__